<div [ngClass]="{'form-control border-0 pb-0 px-0 bg-transparent': inline}">
  @for (option of options; track option; let idx = $index) {
    <div class="form-check" [ngClass]="{'form-check-inline': inline}">
      <input [(ngModel)]="selectedValue" (ngModelChange)="onModelChange()" [value]="option" [disabled]="disabled"
             [name]="id + '-options'" [id]="id + '-' + idx" class="form-check-input" type="radio">
      <label [ngClass]="{'invalid-label': selectedValue === null && required}"
             [attr.for]="id + '-' + idx">{{ formatter(option) }}</label>
    </div>
  }
</div>
